module.exports = __webpack_public_path__ + "static/media/image-card-2.b98e4756.png";